import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import StepPayCheckSection from '../../../StepPayment/components/StepPayCheckSection';

import './single-step-check-area.scss';


export function SingleStepCheckArea(props) {
    const {
        locale,
        paymentProps,
    } = props;

    const {
        handleOpenDeliveryPricePopup,
        subscriptionTypeQuery: { subscriptionType },
        hideRecurrentPayment,
    } = paymentProps;

    const handleOpenDeliveryPricePopupWrapped = useCallback((e) => {
        handleOpenDeliveryPricePopup(e, 'step-by-step-checkout');
    }, [handleOpenDeliveryPricePopup]);

    return (
        <div styleName="single-step-checkout__check">
            <StepPayCheckSection
                {...paymentProps}
                hideRecurrent={hideRecurrentPayment}
                locale={locale}
                subscriptionType={subscriptionType}
                handleOpenDeliveryPricePopup={handleOpenDeliveryPricePopupWrapped}
            />
        </div>
    );
}

SingleStepCheckArea.propTypes = {
    locale: PropTypes.string.isRequired,
    paymentProps: PropTypes.shape({
        handleOpenDeliveryPricePopup: PropTypes.func.isRequired,
        subscriptionTypeQuery: PropTypes.shape({
            subscriptionType: PropTypes.string.isRequired,
        }).isRequired,
        hideRecurrentPayment: PropTypes.bool.isRequired,
    }).isRequired,
};
